import * as userRequest from "@/utils/userRequest";

export default async function getNft(token: string, onSuccess?: (data?: any) => any, handleError?: (err?: any) => any) {
    try {
        const res = await userRequest.get("interests/nft", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getNft ~ res:", res);
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getNft ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
